import {
    apiFetch,
    // apiPost,
    // buildParam
} from "./General";

export const getFAQ = (callback, errorCallback) => {

    apiFetch('faq', '', callback, errorCallback);
}